import { renderNotFound } from '@ice/stark-app';
import BasicLayout from '@/layouts/BasicLayout';
import Home from '@/pages/Home';
import Login from '@/pages/Login/login';
import LoginScan from '@/pages/Login/login_scan';
import H5Scan from '@/pages/Login/h5_scan';
import LoginSession from '@/pages/Login/login_session';
import Password from '@/pages/Profile/password';
import BindUser from '@/pages/Register/bind';

const routerConfig = [
  {
    path: '/',
    component: BasicLayout,
    children: [
      { path: '/', component: Home, exact: true },
      { path: '/login', component: Login, exact: true },
      {path: '/scan_login',component: LoginScan,exact: true},
      {path: '/h5_login',component: H5Scan,exact: true},
      {path: '/session_login',component: LoginSession,exact: true},
      {path: '/password',component: Password,exact: true},
      {path: '/binduser',component: BindUser,exact: true},
      {
        path: '*',
        component: () => renderNotFound(),
      },
    ],
  },
];

export default routerConfig;
